import { $, $1 } from "Utilities/selector";

import ComponentManager from "Components/component-manager";
import LoadManager, { QUEUE } from "Components/load-manager";

class Alert {
  constructor(el) {
    if (!el) return;

    this.el = el;
    this.button = $1('[data-alert="button"]', el);
    this.text = $1('[data-alert="text"]', el);
    this.header = $1('[data-alert="header"]');
    this.height = el.offsetHeight;
    this.headerHeight = this.header.offsetHeight;
    this.storage = window.localStorage;

    this.init = this.init.bind(this);
    this.bind = this.bind.bind(this);
    this.resize = this.resize.bind(this);
    this.toggleText = this.toggleText.bind(this);
    this.toggleStorage = this.toggleStorage.bind(this);

    this.init();
  }

  init() {
    if (!this.storage.getItem("alertClose")) {
      this.toggleText();
    }
    this.resize();
    this.bind();
  }

  resize() {
    this.height = this.el.offsetHeight;
    this.header.style.top = this.height + "px";
    document.body.style.paddingTop = this.height + "px";
  }

  bind() {
    this.button.addEventListener("click", () => {
      this.toggleText();
      this.toggleStorage();
    });
    let resize = utilities.debounce(() => this.resize(), 100);
    window.addEventListener("resize", resize);
  }

  toggleText() {
    this.el.classList.toggle("is-open");
    this.resize();
  }

  toggleStorage() {
    if (this.el.classList.contains("is-open")) {
      this.storage.clear();
    } else {
      this.storage.setItem("alertClose", true);
    }
  }
}

export default LoadManager.queue(
  () => new ComponentManager(Alert, "[data-js~=alert]"),
  QUEUE.DOM
);



// WEBPACK FOOTER //
// ./scripts/components/alert.js